import React from 'react';

/*
 * Exported from the Between DS. Filled rather than stroked, which is why these
 * sit apart from the outline set in the folder above - several of those names
 * are in use on other screens and must keep the drawing they have.
 *
 * The one change from the export: every fill is currentColor, so a row can
 * colour its own icon - see .sidebar-icon in side-nav.css. The exported size is
 * kept rather than forced square; two of these are not square, and the slot
 * caps them without stretching them.
 */

const InternalGroupsIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : '20'}
         height={props.height ? props.height : '20'}
         viewBox="0 0 20 20" fill="none"
    >
        <path d="M5 12.5C5.91667 12.5 6.66667 13.25 6.66667 14.1667C6.66667 15.0833 5.91667 15.8333 5 15.8333C4.08333 15.8333 3.33333 15.0833 3.33333 14.1667C3.33333 13.25 4.08333 12.5 5 12.5ZM5 10.8333C3.16667 10.8333 1.66667 12.3333 1.66667 14.1667C1.66667 16 3.16667 17.5 5 17.5C6.83333 17.5 8.33333 16 8.33333 14.1667C8.33333 12.3333 6.83333 10.8333 5 10.8333ZM10 4.16667C10.9167 4.16667 11.6667 4.91667 11.6667 5.83333C11.6667 6.75 10.9167 7.5 10 7.5C9.08333 7.5 8.33333 6.75 8.33333 5.83333C8.33333 4.91667 9.08333 4.16667 10 4.16667ZM10 2.5C8.16667 2.5 6.66667 4 6.66667 5.83333C6.66667 7.66667 8.16667 9.16667 10 9.16667C11.8333 9.16667 13.3333 7.66667 13.3333 5.83333C13.3333 4 11.8333 2.5 10 2.5ZM15 12.5C15.9167 12.5 16.6667 13.25 16.6667 14.1667C16.6667 15.0833 15.9167 15.8333 15 15.8333C14.0833 15.8333 13.3333 15.0833 13.3333 14.1667C13.3333 13.25 14.0833 12.5 15 12.5ZM15 10.8333C13.1667 10.8333 11.6667 12.3333 11.6667 14.1667C11.6667 16 13.1667 17.5 15 17.5C16.8333 17.5 18.3333 16 18.3333 14.1667C18.3333 12.3333 16.8333 10.8333 15 10.8333Z" fill="currentColor"/>
    </svg>
);

export default InternalGroupsIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/nav/InternalGroupsIcon.jsx